"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIO = void 0;
exports.FIO = new Set(['name', 'surname', 'middlename']);
